import { render, staticRenderFns } from "./r-trigger-johan.vue?vue&type=template&id=2fcab21e&scoped=true"
import script from "./r-trigger-johan.vue?vue&type=script&lang=js"
export * from "./r-trigger-johan.vue?vue&type=script&lang=js"
import style0 from "./r-trigger-johan.vue?vue&type=style&index=0&id=2fcab21e&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcab21e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fcab21e')) {
      api.createRecord('2fcab21e', component.options)
    } else {
      api.reload('2fcab21e', component.options)
    }
    module.hot.accept("./r-trigger-johan.vue?vue&type=template&id=2fcab21e&scoped=true", function () {
      api.rerender('2fcab21e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/trigger/r-trigger-johan.vue"
export default component.exports